<template>
    <form class="form-wrapper">
        <div class="form-group__block">
            <InputGroup
                v-if="passwordInputType === 'password'"
                type="password"
                v-model="password"
                @input="sanitizePassword"
                @blur="sanitizePassword"
                @keydown="preventSpace"
                :placeholder="$t('Create your password')"
                inputId="signup-form-password"
                required
                :isFocusedProp="isFocusedPassword"
                :maxLength="40"
                :errorMessage="passwordError"
                autocomplete="new-password"
                customClass="field-signupform-password password-container"
                inputClass="form-control password"
            />
            <InputGroup
                v-else
                type="text"
                v-model="password"
                @input="sanitizePassword"
                @blur="sanitizePassword"
                @keydown="preventSpace"
                :placeholder="$t('Create your password')"
                inputId="signup-form-password"
                required
                :isFocusedProp="isFocusedPassword"
                :maxLength="40"
                :errorMessage="passwordError"
                autocomplete="new-password"
                customClass="field-signupform-password password-container"
                inputClass="form-control password"
            />
            <span class="view-password" :class="{active: passwordInputType === 'password'}" @click="togglePasswordVisibility"></span>
        </div>

        <div class="form-group__block">
            <InputGroup
                v-if="passwordConfirmInputType === 'password'"
                type="password"
                v-model="passwordConfirm"
                @input="sanitizePasswordConfirm"
                @blur="sanitizePasswordConfirm"
                @keydown="preventSpace"
                :placeholder="$t('Confirm your password')"
                required
                :isFocusedProp="isFocusedPasswordConfirm"
                :maxLength="40"
                autocomplete="new-password"
                :errorMessage="passwordConfirmError"
                customClass="field-signupform-password password-container"
                inputClass="form-control password"
            />
            <InputGroup
                v-else
                type="text"
                v-model="passwordConfirm"
                @input="sanitizePasswordConfirm"
                @blur="sanitizePasswordConfirm"
                @keydown="preventSpace"
                :placeholder="$t('Confirm your password')"
                required
                :isFocusedProp="isFocusedPasswordConfirm"
                :maxLength="40"
                autocomplete="new-password"
                :errorMessage="passwordConfirmError"
                customClass="field-signupform-password password-container"
                inputClass="form-control password"
            />
            
            <span class="view-password" :class="{active: passwordConfirmInputType === 'password'}" @click="togglePasswordConfirmVisibility"></span>
        </div>

        <div 
            class="button button-accent button-authorize-next btn-hover btn-hover--green" 
            :class="{ 'not-changed' : !formValidation }"
            @click="submitNewPassword"
        >
            <span v-if="!isSubmitting">
                {{ $t('Update Password') }}
            </span>
            <div v-else class="btn-preloader btn-preloader--green"></div>
        </div>
    </form>
</template>

<script>
import InputGroup from '/webpack-assets/vue/components/InputGroup.vue';

export default {
    emits: ['activeStepUpdate', 'update-is-two-fa'],
    components: {
        InputGroup,
    },
    props: {
        authData: {
            type: Object,
        },
        token: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            password: '',
            passwordConfirm: '',
            passwordError: '',
            passwordConfirmError: '',
            formLoader: false,
            formValidation: false,
            isSubmitting: false,
            isFocusedPassword: false,
            isFocusedPasswordConfirm: false,
            passwordInputType: 'password',
            passwordConfirmInputType: 'password',
        }
    },
    methods: {
        sanitizeInput(value) {
            if (value !== undefined && value !== null) {
                let valueString = value.toString();
                return valueString.replace(/[а-яА-ЯёЁ]/g, '');
            }
            return value;
        },
        sanitizePassword(event) {
            const passwordPattern = /^(?=.*\d)|(?=.*(_|[^\w])).+$/;
            this.password = this.sanitizeInput(this.password);
            if (this.password.length === 0) {
                this.isFocusedPassword = false;
                this.passwordError = this.$t('{title} cannot be blank', { title: this.$t('Password') });
            } else if (this.password.length < 8) {
                this.isFocusedPassword = true;
                this.passwordError = this.$t('At least {cnt} characters', { cnt: 8 });
            } else if (!passwordPattern.test(this.password)) {
                this.isFocusedPassword = true;
                this.passwordError = this.$t('At least one number (0-9) or special symbol');
            } else if (typeof this.password !== 'string' || this.password.length > 32) {
                this.isFocusedPassword = true;
                this.passwordError = this.$t('{title} should contain at most 32 characters', { title: this.$t('Password') });
            } else {
                this.isFocusedPassword = true;
                this.passwordError = '';
            }
            this.checkFormChange();
            this.checkCountError();
        },
        sanitizePasswordConfirm(event) {
            this.passwordConfirm = this.sanitizeInput(this.passwordConfirm); 

            if (this.passwordConfirm.length === 0) {
                this.isFocusedPasswordConfirm = false;
                this.passwordConfirmError = this.$t('{title} cannot be blank', { title: this.$t('Confirm password') });
            } else if (this.passwordConfirm !== this.password) {
                this.isFocusedPasswordConfirm = true;
                this.passwordConfirmError = this.$t('Password mismatch');
            } else {
                this.isFocusedPasswordConfirm = true;
                this.passwordConfirmError = '';
            }
            this.checkFormChange();
            this.checkCountError();
        },
        checkCountError() {
            if(this.passwordError !== '' && this.passwordConfirmError !== '') {
                this.$emit('change-height-block', 34)
            } else if (this.passwordError !== '' || this.passwordConfirmError !== '') {
                this.$emit('change-height-block', 17) 
            } else {
                this.$emit('change-height-block', 0) 
            }
        },
        preventSpace(event) {
            if (event.key === ' ') {
                event.preventDefault();
            }
        },
        checkFormChange() {
            return this.formValidation = 
                this.password.length &&
                this.passwordConfirm.length &&
                this.password == this.passwordConfirm &&
                !this.passwordError &&
                !this.passwordConfirmError;
        },
        togglePasswordVisibility() {
            this.passwordInputType = this.passwordInputType == 'password' ? 'text' : 'password';
        },
        togglePasswordConfirmVisibility() {
            this.passwordConfirmInputType = this.passwordConfirmInputType == 'password' ? 'text' : 'password';
        },
        
        async submitNewPassword() {
            this.sanitizePassword()
            this.sanitizePasswordConfirm()
            if (this.isSubmitting || !this.formValidation) return;
            this.isSubmitting = true;

            try {
                const formData = new FormData();
                formData.append('ResetPasswordForm[password]', this.password);
                formData.append('ResetPasswordForm[confirm_password]', this.passwordConfirm);
                formData.append('_csrf-frontend', this.authData.csrf);

                const response = await this.$request(`/${this.authData?.language}/auth-api/reset-password?token=${this.token}`, {
                    method: 'POST',
                    body: formData
                });

                const resp = await response.json();
                if (resp.status === 'error') {
                    this.passwordError = resp.errors.password ? resp.errors.password[0] : '';
                    this.passwordConfirmError = resp.errors.confirm_password ? resp.errors.confirm_password[0] : '';
                    this.checkCountError();
                } else if (resp.status === 'success') {
                    this.$emit('change-type', 'password-changed')
                    this.checkCountError();         
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.isSubmitting = false;
            }
        }
    },
}
</script>

<style scoped lang="scss">
.form-input {
    &.email-input {
        padding-left: 48px !important;
    }
}
</style>